var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrifecaseTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.8051C14.2091 18.8051 16 17.0142 16 14.8051C16 12.596 14.2091 10.8051 12 10.8051C9.79086 10.8051 8 12.596 8 14.8051C8 17.0142 9.79086 18.8051 12 18.8051Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 13.5551V14.4851C12.25 14.8351 12.07 15.1651 11.76 15.3451L11 15.8051",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0008 22.6051H16.0008C20.0208 22.6051 20.7408 20.9951 20.9508 19.0351L21.7008 11.0351C21.9708 8.5951 21.2708 6.6051 17.0008 6.6051H7.0008C2.7308 6.6051 2.0308 8.5951 2.3008 11.0351L3.0508 19.0351C3.2608 20.9951 3.9808 22.6051 8.0008 22.6051Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.6051V5.8051C8 4.0351 8 2.6051 11.2 2.6051H12.8C16 2.6051 16 4.0351 16 5.8051V6.6051",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6498 11.6051C19.9198 12.8651 17.9998 13.7451 16.0098 14.2451",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61914 11.8751C4.28914 13.0151 6.10914 13.8251 7.99914 14.2851",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrifecaseTimer);
export default __webpack_public_path__ + "static/media/brifecase-timer.7cf762c11bf22d8f48757c7928c1d0b6.svg";
export { ForwardRef as ReactComponent };